import { Shield, Lock, Eye, Database, Mail, Users } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container max-w-4xl">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
          </div>
          
          <p className="text-gray-500 mb-8">Last updated: January 2025</p>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <Database className="w-5 h-5 text-blue-500" />
                Information We Collect
              </h2>
              <p className="mb-3">When you use AutoSearchSA, we may collect the following information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Search Data:</strong> Vehicle makes, models, price ranges, and other search criteria you use</li>
                <li><strong>Contact Information:</strong> Name, email, and phone number when you submit enquiry forms</li>
                <li><strong>Usage Data:</strong> Pages visited, clicks, time spent on site, and referral sources</li>
                <li><strong>Device Information:</strong> Browser type, IP address, and device identifiers</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <Eye className="w-5 h-5 text-green-500" />
                How We Use Your Information
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>To provide and improve our car search aggregation service</li>
                <li>To connect you with dealers, insurers, and inspection services</li>
                <li>To send you relevant information about vehicles matching your criteria</li>
                <li>To analyse usage patterns and improve user experience</li>
                <li>To comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <Users className="w-5 h-5 text-purple-500" />
                Information Sharing
              </h2>
              <p className="mb-3">We may share your information with:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Service Providers:</strong> When you request inspections, insurance quotes, or finance calculations</li>
                <li><strong>Dealers:</strong> When you click through to view a vehicle on their site</li>
                <li><strong>Analytics Partners:</strong> Aggregated, anonymised data for service improvement</li>
              </ul>
              <p className="mt-3">We do not sell your personal information to third parties.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <Lock className="w-5 h-5 text-red-500" />
                Data Security
              </h2>
              <p>We implement appropriate security measures to protect your personal information. However, no internet transmission is completely secure, and we cannot guarantee absolute security.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">Cookies</h2>
              <p>We use cookies to improve your experience, remember preferences, and analyse site traffic. You can control cookie settings in your browser.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">Your Rights</h2>
              <p className="mb-3">Under POPIA (Protection of Personal Information Act), you have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal information</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <Mail className="w-5 h-5 text-blue-500" />
                Contact Us
              </h2>
              <p>For any privacy-related queries or to exercise your rights, contact us at:</p>
              <p className="mt-2"><strong>Email:</strong> <a href="mailto:autosearchsa@gmail.com" className="text-blue-600 hover:underline">autosearchsa@gmail.com</a></p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
